import { render, staticRenderFns } from "./ProjectPeerEvaluation.vue?vue&type=template&id=65186114"
import script from "./project-peer-evaluation.ts?vue&type=script&lang=ts&external"
export * from "./project-peer-evaluation.ts?vue&type=script&lang=ts&external"
import style0 from "./project-peer-evaluation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports